module.exports = __webpack_public_path__ + "img/BlinkArt_Axe1H_Medium.c91d93db.png";